<section class="beneficios-lista" aria-labelledby="beneficios-lista-titulo">
  <div class="beneficios-lista__cabecalho">
    <div class="beneficios-lista__titulo-grupo">
      <h3 id="beneficios-lista-titulo" class="beneficios-lista__subtitulo">
        Benefícios {{ nomePlano() ? 'do ' + nomePlano() : 'do plano' }}
      </h3>
      <p class="beneficios-lista__descricao">{{ descricao() }}</p>
    </div>
    @if (editavel()) {
      <vivest-button variant="outline" size="sm" data-testid="beneficios-lista-adicionar" (click)="adicionar.emit()">
        <vivest-icon slot="icon-left" name="plus" source="feather"></vivest-icon>
        Adicionar Benefício
      </vivest-button>
    }
  </div>

  @if (beneficios().length) {
    <ul class="beneficios-lista__lista" data-testid="beneficios-lista">
      @for (beneficio of beneficios(); track beneficio.id) {
        <li
          class="beneficios-lista__item"
          [class.beneficios-lista__item--selecionado]="beneficio.id === selecionadoId()"
          [class.beneficios-lista__item--inativo]="!beneficio.ativo"
          [attr.data-testid]="'beneficios-lista-item-' + beneficio.id"
        >
          <button
            type="button"
            class="beneficios-lista__item__abrir"
            [attr.aria-current]="beneficio.id === selecionadoId() ? 'true' : null"
            data-testid="beneficios-lista-abrir"
            (click)="selecionar.emit(beneficio.id)"
          >
            <span class="beneficios-lista__item__nome">{{ beneficio.nome }}</span>
            <!-- Novo: só o selo. Já criado: a disponibilidade e, se pendente, o aviso de não salvo. -->
            @if (idsNovos().has(beneficio.id)) {
              <span class="beneficios-lista__item__estado" data-testid="beneficios-lista-novo">
                <span class="beneficios-lista__item__selo">Novo</span>
                Ainda não salvo
              </span>
            } @else {
              <span class="beneficios-lista__item__estado" data-testid="beneficios-lista-disponibilidade">
                {{ beneficio.ativo ? 'Ativo no autoatendimento' : 'Inativo no autoatendimento' }}
              </span>
              @if (idsAlterados().has(beneficio.id)) {
                <span class="beneficios-lista__item__pendente" data-testid="beneficios-lista-alterado">
                  Alterações não salvas
                </span>
              }
            }
          </button>
          @if (beneficio.id === selecionadoId() && pendente()) {
            <vivest-icon
              class="beneficios-lista__item__alerta"
              name="alert-circle"
              source="feather"
              role="img"
              aria-label="Regras com pendências"
              data-testid="beneficios-lista-pendente"
            ></vivest-icon>
          }
          @if (editavel()) {
            <!-- Ativar/desativar e excluir são gravados na hora (excluir pede confirmação antes). -->
            <vivest-switch
              class="beneficios-lista__item__switch"
              [checked]="beneficio.ativo"
              (change)="ativar.emit({ id: beneficio.id, ativo: $any($event.target).checked })"
              [attr.aria-label]="(beneficio.ativo ? 'Desativar ' : 'Ativar ') + beneficio.nome"
              [attr.title]="beneficio.ativo ? 'Ativo: clique para desativar' : 'Inativo: clique para ativar'"
              data-testid="beneficios-lista-ativo"
            ></vivest-switch>
            <button
              type="button"
              class="beneficios-lista__item__excluir"
              [attr.aria-label]="'Excluir ' + beneficio.nome"
              title="Excluir benefício"
              data-testid="beneficios-lista-excluir"
              (click)="excluir.emit(beneficio.id)"
            >
              <vivest-icon name="trash-2" source="feather" aria-hidden="true"></vivest-icon>
            </button>
          }
        </li>
      }
    </ul>
  } @else {
    <p class="beneficios-lista__vazio" data-testid="beneficios-lista-vazio">{{ vazio() }}</p>
  }
</section>
